export enum RequestResult {
  Requested = 'REQUESTED',
  Followed = 'FOLLOWED',
}
